import storage from '@/utils/storage';
import { defineStore } from 'pinia';

export interface AuthState {
    token?: string;
    refreshToken?: string;
}

// token全局状态
const useAuthStore = defineStore({
    id: 'auth',
    state: (): AuthState => ({
        token: undefined,
        refreshToken: undefined
    }),
    getters: {
        getToken: (state) => state.token,
        getRefreshToken: (state) => state.refreshToken,
        isLogin: (state) => !!state.token,
        getAuthorization: (state) => (state.token ? { authorization: `bearer ${state.token}` } : {})
    },
    actions: {
        initToken() {
            this.token = storage.get('token') || undefined;
            this.refreshToken = storage.get('refreshToken') || undefined;
        },
        setToken(token: string | undefined, refreshToken: string | undefined) {
            storage.set('token', token);
            storage.set('refreshToken', refreshToken);
            this.token = token;
            this.refreshToken = refreshToken;
        },
        deleteToken() {
            storage.set('token', undefined);
            storage.set('refreshToken', undefined);
            this.token = undefined;
            this.refreshToken = undefined;
        }
    }
});

export default useAuthStore;
